<script setup>
import { TagsInputItemText } from 'radix-vue'

const props = defineProps({
  asChild: { type: Boolean, required: false },
  as: { type: null, required: false },
})
</script>

<template>
  <TagsInputItemText v-bind="props">
    <slot />
  </TagsInputItemText>
</template>
